export default __webpack_public_path__ + "static/media/pin.6abf8cc7.svg";